/**
 * ComeOn! specific scroller script. Name chosen arbitrarily to differentiate from the slider, in this case
 * sliding is horizontal and scrolling is vertical :)
 *
 * Built as jQuery plugin. Apply to matching elements. Assumes certain structure inside the element:
 *
 * Any element with class="slideshow" will be turned into the scroller, with the immediate children as slides.
 *
 * Basic usage:
 *
 *     // activate scroller
 *     $('#activity-feed').scroller();
 *
 *     // activate scroller, but change direction from the default down to up
 *     $('#activity-feed').scroller({direction: 'up'});
 *
 *     // stop scroller if running
 *     $('#activity-feed').scrollerStop();
 *
 *     // replace the current slides with new ones
 *     $('#activity-feed').scrollerReplaceSlides(function () {
 *         $(this).append($('<div>A new slide</div>'));
 *         $(this).append($('<div>Another new slide</div>'));
 *     );
 */
define('all/scroller',['jquery'], function($) {
	'use strict';

	var DEFAULTS = {
		direction: 'down',
		speed: 800,
		delay: 3000,
		auto: true
	};

	function removeElementsBelowView($slideshow) {
		var height = getSlideshowHeight($slideshow);
		$slideshow.children(':not(template)').each(function () {
			if (height <= 0) {
				$(this).remove();
			} else {
				height -= $(this).outerHeight();
			}
		});
	}

	function removeElementsAboveView($slideshow) {
		var originalMarginTop = parseInt($slideshow.css('marginTop'), 10);
		var totalHeight = 0;
		var removedHeight = 0;
		var $childrenAboveView = $slideshow.children(':not(template)').filter(function () {
			totalHeight += $(this).outerHeight();
			var shouldBeRemoved = originalMarginTop + totalHeight <= 0;
			if (shouldBeRemoved) {
				removedHeight += $(this).outerHeight();
			}
			return  shouldBeRemoved;
		});
		$childrenAboveView.remove();
		$slideshow.css('marginTop', originalMarginTop + removedHeight);
	}

	function removeElementsLeftOfView($slideshow) {
		var originalMarginLeft = parseInt($slideshow.css('marginLeft'), 10);
		var totalWidth = 0;
		var removedWidth = 0;
		var $childrenLeftOfView = $slideshow.children(':not(template)').filter(function () {
			totalWidth += $(this).outerWidth();
			var shouldBeRemoved = originalMarginLeft + totalWidth <= 0;
			if (shouldBeRemoved) {
				removedWidth += $(this).outerWidth();
			}
			return  shouldBeRemoved;
		});
		$childrenLeftOfView.remove();
		$slideshow.css('marginLeft', originalMarginLeft + removedWidth);
	}

	function removeElementsRightOfView($slideshow) {
		var width = getSlideshowWidth($slideshow);
		$slideshow.children(':not(template)').each(function () {
			if (width <= 0) {
				$(this).remove();
			} else {
				width -= $(this).outerWidth();
			}
		});
	}

	function changeSlide($slideshow, $slides, options, pageDelta) {
		if ($slideshow.data('animating')) {
			return;
		}
		$slideshow.data('animating', true);
		if (pageDelta === 0) {
			return;
		}
		var $nextSlide;
		var horizontalMovement = 0;
		var verticalMovement = 0;
		var forwards = pageDelta > 0;
		var movingUp = options.direction === 'up' && forwards || options.direction === 'down' && !forwards;
		var movingDown = options.direction === 'down' && forwards || options.direction === 'up' && !forwards;
		var movingLeft = options.direction === 'left' && forwards || options.direction === 'right' && !forwards;
		var movingRight = options.direction === 'right' && forwards || options.direction === 'left' && !forwards;
		for (var page = 0; page < Math.abs(pageDelta); page++) {
			if (forwards) {
				$slides.append($slides.children().first());
			} else {
				$slides.prepend($slides.children().last());
			}
			//At most showing the first and last three pages when scrolling far to make it smoother
			if (page > 2 && Math.abs(pageDelta) - page > 2) {
				continue;
			}
			$nextSlide = $slides.children().first();
			var populate = $nextSlide.data('populate');
			if (typeof populate === 'function') {
				populate();
			}
            var $firstChildren=$slides.children().first();
            var templateHtml=$firstChildren.find('template').html();
			$nextSlide = $firstChildren.clone(true);
            $nextSlide.find('template').html(templateHtml);
			if (movingUp) {
				$slideshow.append($nextSlide);
				verticalMovement -= $nextSlide.outerHeight();
			} else if (movingDown) {
				$slideshow.prepend($nextSlide);
				var previousMarginTop = parseInt($slideshow.css('marginTop'), 10);
				$slideshow.css('marginTop', -$nextSlide.outerHeight() + previousMarginTop);
				verticalMovement += $nextSlide.outerHeight();
			} else if (movingLeft) {
				$slideshow.append($nextSlide);
				horizontalMovement -= $nextSlide.outerWidth();
			} else if (movingRight) {
				var previousMarginLeft = parseInt($slideshow.css('marginLeft'), 10);
				$slideshow.prepend($nextSlide);
				$slideshow.css('marginLeft', -$nextSlide.outerWidth() + previousMarginLeft);
				horizontalMovement += $nextSlide.outerWidth();
			} else {
				throw 'scroller.js: Unrecognized direction ' + options.direction;
			}
		}
		var targetMargin;
		if (movingLeft || movingRight) {
			var width = 0;
			$slideshow.children(':not(template)').each(function () {
				width += $(this).outerWidth();
			});
			$slideshow.css('width', width);
			targetMargin = {
				marginLeft: parseInt($slideshow.css('marginLeft'), 10) + horizontalMovement
			};
		} else {
			targetMargin = {
				marginTop: parseInt($slideshow.css('marginTop'), 10) + verticalMovement
			};
		}
		$slideshow.data('currentPage', $nextSlide.data('scrollerPage'));
		$slideshow.trigger('scroller.pageChangeBegin');
		$slideshow.animate(targetMargin, {
			duration: options.speed,
			queue: false,
			done: function () {
				if (movingUp) {
					removeElementsAboveView($slideshow);
				} else if (movingDown) {
					removeElementsBelowView($slideshow);
				} else if (movingLeft) {
					removeElementsLeftOfView($slideshow);
				} else if (movingRight) {
					removeElementsRightOfView($slideshow);
				}
				$slideshow.data('animating', null);
				animate($slideshow);
			}
		});
	}

	function animate($slideshow) {
		clearTimeout($slideshow.data('timeout'));
		var options = $.extend({}, DEFAULTS, $slideshow.data('options'));
		if (options.auto) {
			var timeout = setTimeout(function () {
				if (!$slideshow.data('scrolling')) {
					return;
				}
				var $slides = ensureSlidesPlaceholder($slideshow);
				if ($slides.children().length === 0) {
					animate($slideshow);
					return;
				}
				changeSlide($slideshow, $slides, options, 1);
			}, options.delay);
			$slideshow.data('timeout', timeout);
		}
	}

	function ensureSlidesPlaceholder($slideshow) {
		var $slides = $slideshow.data('slides');
		if (!$slides) {
			$slides = $('<div>').hide();
			$slideshow.after($slides);
			$slideshow.data('slides', $slides);
		}
		return $slides;
	}

	function getSlideshowHeight($slideshow) {
		var height = $slideshow.parent().innerHeight();
		if (height !== 0) {
			return height;
		} else {
			return $slideshow.outerHeight(true);
		}
	}

	function getSlideshowWidth($slideshow) {
		var width = $slideshow.parent().innerWidth();
		if (width !== 0) {
			return width;
		} else {
			return $slideshow.outerWidth(true);
		}
	}

	function preFillVerticalSlideshow($slideshow, $slides, options) {
		var heightToCover = getSlideshowHeight($slideshow);
		while (heightToCover > 0) {
			var $nextSlide = $slides.children().first();
			$slides.append($nextSlide);
			$nextSlide = $nextSlide.clone(true);
			if (options.direction === 'down') {
				$slideshow.prepend($nextSlide);
			} else { // options.direction === 'up'
				$slideshow.append($nextSlide);
			}
			heightToCover -= $nextSlide.outerHeight();
		}
		if (options.direction === 'up') {
			$slideshow.children(':not(template)').first().css('marginTop', heightToCover);
		}
	}

	function preFillHorizontalSlideshow($slideshow, $slides) {
		var $nextSlide = $slides.children().first();
        var templateHtml=$nextSlide.find('template').html();
		$nextSlide = $nextSlide.clone(true);
		$slideshow.append($nextSlide);
        $nextSlide.find('template').html(templateHtml);
    }

	function preFillSlideshow($slideshow, options) {
		var $slides = ensureSlidesPlaceholder($slideshow);
		if ($slides.children().length === 0) {
			return;
		}
		if (options.direction === 'up' || options.direction === 'down') {
			preFillVerticalSlideshow($slideshow, $slides, options);
		} else {
			preFillHorizontalSlideshow($slideshow, $slides);
		}
	}

	function shouldShowPage(page, pages, currentPage) {
		if (page === 0) {
			return true;
		}
		if (page === pages - 1) {
			return true;
		}
		if (currentPage < 4 && page < 6) {
			return true;
		}
		if ((pages - 1) - currentPage < 4 && (pages - 1) - page < 6) {
			return true;
		}
		return Math.abs(page - currentPage) < 3;
	}

	function drawDirectPageNavigation($pagination, pages, numbered, currentPage, $container) {
		$pagination.find('ul').each(function () {
			$(this).empty();
			for (var page = 0; page < pages; page++) {
				var content;
				var active = page === currentPage;
				if (numbered) {
					var first = page === 0;
					var last = page === pages - 1;
					var shouldShow = first || last || shouldShowPage(page, pages, currentPage);
					if (!shouldShow) {
						continue;
					}
					var dots = '';
					var dotsClass = '';
					if (first && !shouldShowPage(page + 1, pages, currentPage) || last && !shouldShowPage(page - 1, pages, currentPage)) {
						dots = '<span class="dots">...</span>';
						dotsClass = ' class="' + (first ? 'first' : 'last') + '"';
					}
					content = '<li data-page="' + page + '"' + dotsClass + '>' + dots + '<a class="filterfix' + (active ? ' active' : '') + '"><span class="number">' + (page + 1) + '</span></a></li>';
				} else {
					content = '<li data-page="' + page + '"' + (active ? ' class="active"' : '') + '><a></a></li>';
				}
				var $directPageNavigation = $(content);
				$directPageNavigation.find('a').on('click', page, function (event) {
					event.preventDefault();
					if (!$(this).hasClass('active')) {
						$container.scrollerGotoPage(event.data);
					}
				});
				$(this).append($directPageNavigation);
			}
		});
	}

	function initializePager($container, $slides, $slideshow) {
		$container.find('.ui-pagination,.ui-pagination-numbered').each(function () {
			var numbered = $(this).is('.ui-pagination-numbered');
			var pages = $slides.children().length;
			if (pages > 1) {
				var $pagination = $(this);
				$pagination.show();
				$pagination.find('.next').off('click').click(function (event) {
					event.preventDefault();
					$container.scrollerNext();
				});
				$pagination.find('.prev').off('click').click(function (event) {
					event.preventDefault();
					$container.scrollerPrevious();
				});
				drawDirectPageNavigation($pagination, pages, numbered, $slideshow.data('currentPage'), $container);
				$slideshow.off('scroller.pageChangeBegin').on('scroller.pageChangeBegin', function () {
					if (numbered) {
						drawDirectPageNavigation($pagination, pages, numbered, $slideshow.data('currentPage'), $container);
					} else {
						$pagination.find('li').removeClass('active');
						$pagination.find('li[data-page="' + $slideshow.data('currentPage') + '"]').addClass('active');
					}
				});
			} else {
				$(this).hide();
			}
		});
	}

	$.fn.scrollerStop = function () {
		this.each(function () {
			var $slideshow = $(this).find('.slideshow');
			if ($slideshow.data('scrolling')) {
				var $slides = $slideshow.data('slides');
				$slideshow.children(':not(template)').remove();
				$slideshow.append($slides.children());
				$slides.remove();
				$slideshow.data('scrolling', null);
				$slideshow.data('slides', null);
				$slideshow.data('options', null);
				clearTimeout($slideshow.data('timeout'));
				$slideshow.data('timeout', null);
			}
		});
		return this;
	};

	$.fn.scrollerReplaceSlides = function (slideCreatingCallback) {
		this.each(function () {
			var $slideshow = $(this).find('.slideshow');
			var $slides = ensureSlidesPlaceholder($slideshow);
			$slides.empty();
			slideCreatingCallback.call($slides);
			var page = 0;
			var $children = $slideshow.children(':not(template)');
			$children.each(function () {
				$(this).data('scrollerPage', page++);
			});
			initializePager($(this), $slides, $slideshow);
		});
		return this;
	};

	$.fn.scroller = function (options) {
		options = $.extend({}, DEFAULTS, options);

		if (options.direction !== 'down' && options.direction !== 'up' && options.direction !== 'left' && options.direction !== 'right') {
			throw 'scroller.js: Only "up", "down", "left" or "right" is allow as directions';
		}

		this.each(function () {
			var $slideshow = $(this).find('.slideshow');
			if (!$slideshow.data('scrolling')) {
				$slideshow.data('scrolling', true);
				options.delay = $slideshow.data('delay') * 1000 || options.delay;
				$slideshow.data('options', options);
				$slideshow.data('currentPage', 0);
				var $slides = ensureSlidesPlaceholder($slideshow);
				var $children = $slideshow.children(':not(template)');
				var page = 0;
				$children.each(function () {
					$(this).data('scrollerPage', page++);
				});
				$slides.append($children);
				preFillSlideshow($slideshow, options);
				animate($slideshow);
				initializePager($(this), $slides, $slideshow);
			}
		});
		return this;
	};

	$.fn.scrollerNext = function () {
		this.each(function () {
			var $slideshow = $(this).find('.slideshow');
			if (!$slideshow.data('scrolling')) {
				throw 'scroller.js: Can only go to next slide if scroller is initialized';
			}
			var $slides = ensureSlidesPlaceholder($slideshow);
			var options = $slideshow.data('options');
			changeSlide($slideshow, $slides, options, 1);
		});
		return this;
	};

	$.fn.scrollerPrevious = function () {
		this.each(function () {
			var $slideshow = $(this).find('.slideshow');
			if (!$slideshow.data('scrolling')) {
				throw 'scroller.js: Can only go to previous slide if scroller is initialized';
			}
			var $slides = ensureSlidesPlaceholder($slideshow);
			var options = $slideshow.data('options');
			changeSlide($slideshow, $slides, options, -1);
		});
		return this;
	};

	$.fn.scrollerGotoPage = function (n) {
		this.each(function () {
			var $slideshow = $(this).find('.slideshow');
			if (!$slideshow.data('scrolling')) {
				throw 'scroller.js: Can only scroll to page if scroller is initialized';
			}
			var $slides = ensureSlidesPlaceholder($slideshow);
			var options = $slideshow.data('options');
			var currentPage = $slideshow.data('currentPage');
			changeSlide($slideshow, $slides, options, n - currentPage);
		});
		return this;
	};
});

